import { SendEmailPayload } from "../../commonTypes/clientDirectoryTypes";
import {
  STICKY_FIRST_LEAD_DIRECTORY_LIST_HEADERS,
  STICKY_LEAD_DIRECTORY_LIST_HEADERS,
} from "../../constant/tableHeadersConstants/LeadDirectoryConstants/leadDirectoryListTableHeaders";
import { TableHeadersType } from "../../constant/tableHeadersConstants/tableHeadersType";
import { TableHeader, TableLoader } from "../commons";
import InfiniteLoader from "../commons/InfiniteLoader/InfiniteLoader";
import ScrollToTop from "../commons/ScrollToTop";
import LeadModuleActionTableData from "./LeadModuleActionTableData";
import LeadModuleFirstColumnTableData from "./LeadModuleFirstColumnTableData";
import LeadModuleTableData from "./LeadModuleTableData";

type AppProps = {
  offset: number;
  fetching: boolean;
  isEditClientLeadDetailsPresent: boolean;
  leadDirectoryList: [] | any[];
  tableHeader: [] | TableHeadersType[];
  handleEditLeadModule: (id: number) => void;
  handleToggleLeadCommentsModal?: () => void;
  handleSetLeadData?: (data: any) => void;
  handleHistoryLeadModule: (data: any) => void;
  openDrawer: (data: any) => void;
  closeDrawer: () => void;
  handleToggleSentEmailToLead: () => void;
  handleSentEmailToLead: (data: SendEmailPayload) => void;
  handleSendEmail: (data: SendEmailPayload) => void;
  isEmailLeadDetailsPresent: boolean;
  handleChangeLeadStatus:(data:any)=>void;
};
const LeadModuleListTable = ({
  offset,
  fetching,
  tableHeader,
  leadDirectoryList,
  handleEditLeadModule,
  isEditClientLeadDetailsPresent,
  handleToggleLeadCommentsModal,
  handleSetLeadData,
  handleHistoryLeadModule,
  openDrawer,
  closeDrawer,
  handleToggleSentEmailToLead,
  handleSentEmailToLead,
  handleSendEmail,
  isEmailLeadDetailsPresent,
  handleChangeLeadStatus
}: AppProps) => {
  return (
    <div className="d-flex">
      {fetching && offset === 0 ? (
        <TableLoader Rows={7} ColumnPerRow={7} />
      ) : (
        <>
          <div className="new-table-style">
            <table className="table table-bordered thead-light">
              <thead className="text-start">
                  <TableHeader
                    tableHeader={STICKY_FIRST_LEAD_DIRECTORY_LIST_HEADERS}
                  />
              </thead>
              <tbody>
                <LeadModuleFirstColumnTableData
                  tableHeader={STICKY_FIRST_LEAD_DIRECTORY_LIST_HEADERS}
                  leadDirectoryList={leadDirectoryList}
                  openDrawer={openDrawer}
                  offset={offset}
                />
              </tbody>
            </table>
          </div>
          <div className="new-table-style" style={{ overflowX: "scroll" }}>
            <table className="table table-bordered thead-light">
              <thead className="text-start sticky-table-header">
                <TableHeader tableHeader={tableHeader} />
              </thead>
              <tbody>
                <LeadModuleTableData
                  tableHeader={tableHeader}
                  leadDirectoryList={leadDirectoryList}
                  handleEditLeadModule={handleEditLeadModule}
                  handleSetLeadData={handleSetLeadData}
                  handleToggleLeadCommentsModal={handleToggleLeadCommentsModal}
                  handleChangeLeadStatus={handleChangeLeadStatus}
                  isEditClientLeadDetailsPresent={
                    isEditClientLeadDetailsPresent
                  }
                  offset={offset}
                />
                {fetching && offset > 0 && <div>{<InfiniteLoader />}</div>}
                <div style={{ display: fetching ? "none" : "inline" }}>
                  <ScrollToTop />
                </div>
              </tbody>
            </table>
          </div>
          <div className="new-table-style">
            <table className="table table-bordered thead-light">
              <thead className="text-start">
                  <TableHeader
                    tableHeader={STICKY_LEAD_DIRECTORY_LIST_HEADERS}
                  />
              </thead>
              <tbody>
                <LeadModuleActionTableData
                  tableHeader={STICKY_LEAD_DIRECTORY_LIST_HEADERS}
                  leadDirectoryList={leadDirectoryList}
                  handleEditLeadModule={handleEditLeadModule}
                  handleSetLeadData={handleSetLeadData}
                  handleToggleLeadCommentsModal={handleToggleLeadCommentsModal}
                  isEditClientLeadDetailsPresent={
                    isEditClientLeadDetailsPresent
                  }
                  handleHistoryLeadModule={handleHistoryLeadModule}
                  handleToggleSentEmailToLead={handleToggleSentEmailToLead}
                  handleSentEmailToLead={handleSentEmailToLead}
                  // handleSendEmail={handleSendEmail}
                  isEmailLeadDetailsPresent={isEmailLeadDetailsPresent}
                  offset={offset}
                />
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default LeadModuleListTable;
